<template>
	<div >
		<el-card class="box-card" shadow="never" style="min-height: 40px" v-loading="loading" >
			<div v-if="chartOption">
				<div class="asin-chart-box" v-loading="config.asinChartLoading">
					<el-row>
						<el-col :span="6">
							<div class="chart-box">
								<p>价格分布</p>
								<chart-sub :option="asinMetrics.price" v-if="asinMetrics.price" :data_height="150"></chart-sub>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="chart-box">
								<p>Reviews评分分布</p>
								<chart-sub :option="asinMetrics.star" v-if="asinMetrics.star" :data_height="150"></chart-sub>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="chart-box">
								<p>Reviews数量分布</p>
								<chart-sub :option="asinMetrics.ratings" v-if="asinMetrics.ratings"  :data_height="150"></chart-sub>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="chart-box"
								style="margin-left: 10px;padding-left: 10px;border-left: 1px solid #E4E7ED">
								<p style="border-bottom: 1px solid #E4E7ED;">
									高频词(
									<span v-if="asinMetrics.words">{{ asinMetrics.words.metadata.length }}</span>
									<span v-else class="no-data-font"> -- </span>)
								</p>
								<div style="height: 150px;overflow-y: auto;" v-if="asinMetrics.words">
									<copy-sub v-for="(word,key) in asinMetrics.words.metadata" :key="key" :value="word">
										<div class="word-item"  >
															<span>
																{{ word }}
																<span class="color-text-grey-1">({{ asinMetrics.words.value[key] }})</span>
															</span>
										</div>
									</copy-sub>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<div style="max-height: 270px;overflow-y: auto;">
					<el-col :span="2" v-for="(item,key) in asinMap" :key="'t1-'  + key" style="text-align: center">
						{{ void (asinInfo=asinInfoMap[item.key])}}
						<asin-sub :country="search.country" :asinInfo="asinInfo || { product_image : '',asin : item.asin }" :showRank="false">
							<div class="div-border-1"
								style="width: 60px;height: 60px;text-align: center;margin-bottom: 10px;padding: 10px;position: relative;cursor: pointer;">
								<div class="appear-num-badge">{{ item.doc_count }}</div>
								<!-- <el-image :src="imgSizeSet(asinInfo ? asinInfo.product_image : '',100)" fit="contain" lazy style="height: 90%;width: 90%"></el-image> -->
								<div v-if="asinInfo && asinInfo.product_image">
									<el-image :src="imgSizeSet(asinInfo ? asinInfo.product_image : '',100)"
																	fit="contain"
																	lazy
																	style="height:100%;width:100%;">
										<div slot="placeholder">
											<i class="el-icon-loading"></i>
										</div>
									</el-image>
								</div>
								<div v-else>
									<i class="el-icon-loading"></i>
								</div>
							</div>
						</asin-sub>
					</el-col>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
import { COUNTRY_CODE_MAP, getSymbolByValue } from "@/components/config/countryCodeConfig";
import Chart from "@/components/template/otherSub/hightChartSub";
import {
	api_getAsinNumTrendByBrand,
} from "@/components/api/keywordReverseSearch";
import { formatAsinReverseSearchTrends } from "@/components/config/chart/asinReverseLookup";
import { formatAsinNumTrendsByBrand } from "@/components/config/chart/asinNumByBrand";
import { api_asin_batchAsinInfoQuery_public, api_asin_queryAsinMetrics } from "@/components/api/asinBasiceInfo";
import { formatKeywordsAsinTrends1 } from "@/components/config/chart/keywordAnalysisAsin";
import { transformArrayToObj } from "@/components/common/utils/util";
import ASIN_INFO_SUB from "@/components/template/view/keywordsTrend/sub/asinInfoPopoverSub";
import { imgSizeSet } from "@/components/common/utils/imgUtils";
import COPY_SUB from "@/components/template/otherSub/copySub";
import {
	formatSearchDataMethod
} from "@/components/template/view/keywordReverseSearch/mixins/weeklyKeywords";

export default {
	name: "brandTrends",
	inject: ['WINDOW', 'F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'F_LOGIN', 'LOGINUSER'],
	mixins : [formatSearchDataMethod],
	data() {
		return {
			windowObj: this.WINDOW,
			loginUser: this.LOGINUSER,
			loading : false,
			config : {
				asinChartLoading : false
			},
			chartOption : null,
			search : {
				brand : null,
				country : null,
				startTime : null,
				endTime : null
			},
			asinMap : [],
			asinInfoMap : {},
			asinMetrics : {},
			loadAsinLock : false
		};
	},
	props : {
		brand : {},
		date: {},
		startTime: {},
		endTime: {},
		keywordsSearch : {},
		country : {
			default : COUNTRY_CODE_MAP[0].value
		},

	},
	components : {
		'chart-sub': Chart,
		'asin-sub': ASIN_INFO_SUB,
		'copy-sub': COPY_SUB,
	},
	created() {
		this.$data.search.brand = this.brand
		this.$data.search.country = this.country
		if (this.startTime){
			this.$data.search.startTime = this.startTime
		}
		if (this.endTime){
			this.$data.search.endTime = this.endTime
		}
		if (this.date){
			this.$data.search.date = this.date
		}
		this.$options.methods.loadTrend(this)
	},
	methods: {
		loadTrend : function(this_) {
			this_ = this_ || this
			let obj = this_.$options.methods.formatSearchData(this_,this_.keywordsSearch)
			let search = { ...this_.$data.search,...obj}
			this_.$data.loading = true
			api_getAsinNumTrendByBrand(search).then(res => {
				this_.$data.asinMetrics = {}
				let data = res.data
				this_.$data.asinMap = data.results
				//加载ASIN详细数据
				this_.$options.methods.loadAsinInfo(this_,data.results.map(i => i.key))
				let option = formatAsinNumTrendsByBrand(data.results)
				// 绑定事件
				option.plotOptions.series.events.click = (e) => {
					this_.$emit('clickColumn',e.point.name)
				}
				this_.$data.chartOption = option
				this_.$data.loading = false
			}).catch(err => {
				this_.$data.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '加载失败，请重新尝试'), 4)
			})
		},
		loadAsinInfo : function(this_,asins) {
			this_ = this_ || this

			let arr = asins.filter(i => !this_.$data.asinInfoMap[i])
			if(arr.length <= 0 || this_.$data.loadAsinLock){
				if (asins.length > 0){
					this_.$options.methods.loadAsinMetrics(this_)
				}
				return
			}
			// 上锁
			this_.$data.loadAsinLock = true
			let  country = this_.country
			// console.log(country)
			api_asin_batchAsinInfoQuery_public([...asins], country).then(res => {
				res.data.forEach(i => {
					i.product_image = i.imgs ? i.imgs[0] : ''
					this_.$set(this_.$data.asinInfoMap,i.asin,i)
				})
				//加载ASIN价格等趋势图表
				this_.$options.methods.loadAsinMetrics(this_)
				// 解锁
				this_.$data.loadAsinLock = false
			}).catch(err => {
				// 解锁
				this_.$data.loadAsinLock = false
				console.error(err)
			})
		},
		loadAsinMetrics : function(this_) {
			this_ = this_ || this
			let arr = []
			this_.$data.asinMap.forEach(item => {
				let i = this_.$data.asinInfoMap[item.key]
				if (i){
					if (i.title || i.price || i.score || i.commentNum){
						let obj = {title : i.title, price : i.price,star : i.score, ratings : i.commentNum}
						arr.push(obj)
					}
				}

			})
			//  开启遮罩
			this_.$data.config.asinChartLoading = true
			let  country = this_.country
			let obj = { list : arr ,country :country  }
			api_asin_queryAsinMetrics(obj).then(res => {
				let data = res.data
				let symbols = getSymbolByValue(country)
				this_.$data.asinMetrics = {}
				this_.$data.asinMetrics.words = data.find(i => i.id === 'words')
				let star = data.find(i => i.id === 'star')
				if (star){
					this_.$data.asinMetrics.star = formatKeywordsAsinTrends1(star.value,star.metadata,'评分分布','#faad14')
				}
				let price = data.find(i => i.id === 'price')
				if (price){
					this_.$data.asinMetrics.price = formatKeywordsAsinTrends1(price.value,price.metadata,'价格分布','#f5222d',symbols)
				}
				let ratings = data.find(i => i.id === 'ratings')
				if (ratings){
					this_.$data.asinMetrics.ratings = formatKeywordsAsinTrends1(ratings.value,ratings.metadata,'评分数分布','#52c41a')
				}
				//  关闭遮罩
				this_.$data.config.asinChartLoading = false
			}).catch(err => {
				//  关闭遮罩
				this_.$data.config.asinChartLoading = false
				console.error(err)
				this_.F_alertMsg(this_.F_getErrMSg(err, '加载失败，请稍后重试'), 4)
			})
		},
		imgSizeSet: function(url, s) {
			if (!url) return null
			return imgSizeSet(url, s)
		}
	}, watch: {
		// brand : {
		// 	handler() {
		// 		console.log("brand"+this.brand)
		// 		this.$options.methods.loadTrend(this)
		// 	},
		// 	deep: true
		// },
		// country: {
		// 	handler() {
		// 		console.log("country"+this.country)
		// 		this.$options.methods.loadTrend(this)
		// 	},
		// 	deep: true
		// },
		// date: {
		// 	handler() {
		// 		console.log("date"+this.date)
		// 		this.$options.methods.loadTrend(this)
		// 	},
		// 	deep: true
		// },
		// startTime: {
		// 	handler() {
		// 		console.log("startTime"+this.startTime)
		// 		this.$options.methods.loadTrend(this)
		// 	},
		// 	deep: true
		// },
		// endTime: {
		// 	handler() {
		// 		console.log("endTime"+this.endTime)
		// 		this.$options.methods.loadTrend(this)
		// 	},
		// 	deep: true
		// },
		windowObj: {
			handler() {
			},
			deep: true
		},
		loginUser: {
			handler() {
			},
			deep: true
		}
	}
}
</script>

<style scoped>
.asin-chart-box{
	margin-bottom: 10px;
	padding-bottom: 10px;
	border-bottom: 1px solid #E4E7ED ;
}

.asin-chart-box .chart-box p{
	color:#909399;
	padding-top: 0;
	margin-top: 0;
	padding-bottom: 8px;
	margin-bottom: 8px;
	font-size: 14px;
}
.asin-chart-box .chart-box .word-item{
	display: inline-block;
	border: 1px solid #EBEEF5;
	border-radius: 30px;
	padding: 3px 10px;
	margin-bottom: 5px;
	font-size: 12px;
	cursor: pointer;
	margin-right: 8px;
}
.asin-chart-box .chart-box .word-item:hover{
	background: #fff;
	border-color: #409eff;
	color: #409eff;
}
.appear-num-badge{
	position: absolute;
	left: 0;
	top: 0;
	border-radius: 10px;
	height: 18px;
	padding: 0 6px;
	z-index: 1;
	color: #FFFFFF;
	text-align: center;
	line-height: 18px;
	font-size: 12px;
	background-color: #409EFF;
}
</style>